(function () {
  'use strict';

  function initCategorieSearch(input) {
    if (input.dataset.categorieSearchInit) return;
    input.dataset.categorieSearchInit = '1';

    var list = input.parentNode.nextElementSibling;
    if (!list || list.tagName !== 'UL') return;

    var items = Array.prototype.slice.call(list.querySelectorAll('li'));

    function getItemText(li) {
      var label = li.querySelector('label');
      if (!label) return '';
      var clone = label.cloneNode(true);
      var svgs = clone.querySelectorAll('svg');
      for (var i = 0; i < svgs.length; i++) svgs[i].remove();
      return clone.textContent.trim().toLowerCase();
    }

    function filterItems(q) {
      items.forEach(function (li) {
        if (q) {
          var match = getItemText(li).indexOf(q) !== -1;
          if (match) {
            if (li.classList.contains('hidden')) {
              li.dataset.wasHidden = '1';
              li.classList.remove('hidden');
            }
            li.style.display = '';
          } else {
            li.style.display = 'none';
          }
        } else {
          if (li.dataset.wasHidden) {
            li.classList.add('hidden');
            delete li.dataset.wasHidden;
          }
          li.style.display = '';
        }
      });
    }

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); }
      if (e.key === 'Escape') { input.value = ''; filterItems(''); }
    });

    input.addEventListener('input', function (e) {
      e.stopPropagation();
      e.stopImmediatePropagation();
      var q = this.value.trim().toLowerCase();
      if (!q || q.length < 3) { filterItems(''); return; }
      filterItems(q);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-facet-categorie-search]').forEach(initCategorieSearch);
  }

  var observer = new MutationObserver(initAll);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }
})();
